import type { TranslationModule } from '../types';

export const jurnalPracticaJudiciaraTranslations: TranslationModule = {
  ro: {
    seoTitle: "Jurnal de practică judiciară — analize, spețe și bune practici | Legea Aplicată",
    seoDesc: "Explorează Jurnalul de practică judiciară din România. Culegeri oficiale ale curților de apel și tribunalelor, analize aplicate, temeiuri de drept și bune practici.",
    eyebrow: "Selecții și culegeri ale instanțelor",
    title: "Jurnal de practică judiciară",
    description: "Analize aplicate, bune practici și probleme de drept extrase din culegerile oficiale ale curților de apel și tribunalelor.",
    totalRecords: "{count} înregistrări juridice",
    searchPlaceholder: "Ex.: prescripție, competență, clauze abuzive, reziliere contract...",
    searchButton: "Caută",
    searchAriaLabel: "Caută în Jurnalul de practică judiciară",
    exploreEyebrow: "Explorează colecția",
    frequentMattersHeading: "Materii frecvente",
    filtersToggle: "Filtre",
    filtersHeading: "Filtrare juridică",
    closeFilters: "Închide filtrele",
    activeFiltersLabel: "Filtre active",
    resetFilters: "Resetează filtrele",
    filterMatter: "Materie",
    allMatters: "Toate materiile",
    filterCourt: "Instanță",
    allCourts: "Toate instanțele",
    filterSection: "Secție",
    allSections: "Toate secțiile",
    filterRulingType: "Tip hotărâre",
    allRulingTypes: "Toate tipurile",
    filterYear: "An",
    allYears: "Toți anii",
    filterSourceType: "Tip document-sursă",
    allSourceTypes: "Toate sursele",
    filterIssuer: "Emitent",
    allIssuers: "Toți emitenții",
    filterPath: "Cale",
    allPaths: "Toate căile",
    filterSubpath: "Subcale",
    allSubpaths: "Toate subcăile",
    filterNote: "Notă",
    allNotes: "Toate",
    withNote: "Cu notă",
    withoutNote: "Fără notă",
    searching: "Se caută…",
    resultsCount: "{count} rezultate",
    resultsFor: "Rezultate pentru „{query}”",
    defaultResultsTitle: "Practica instanțelor, organizată și filtrabilă",
    sortLabel: "Sortare",
    sortRelevance: "Relevanță",
    sortMostRecent: "Cele mai recente",
    sortDateDesc: "Data descrescător",
    sortDateAsc: "Data crescător",
    sortCourtAsc: "Instanță A–Z",
    sortEditorial: "Ordine în sursă",
    loadErrorTitle: "Jurnalul nu a putut fi încărcat.",
    loadingResults: "Se încarcă rezultatele…",
    noResultsTitle: "Niciun rezultat găsit",
    noResultsDesc: "Încearcă o formulare mai scurtă sau resetează filtrele.",
    paginationPrev: "Anterior",
    paginationNext: "Următor",
    paginationPage: "Pagina {page} din {total}",
    cardContainsNote: "Conține notă",
    legalBasis: "Temei:",
    cardPage: "pag. {start}",
    cardPageRange: "pag. {start}–{end}",
    cardReadAnalysis: "Citește analiza",
    researchGuide: "Repere pentru cercetare",
    officialSourceLink: "Verifică culegerile oficiale — Portalul Instanțelor de Judecată",
    detailBreadcrumbHome: "Acasă",
    detailBreadcrumbJournal: "Jurnal de practică judiciară",
    detailBack: "Înapoi la Jurnal",
    detailLoadError: "Înregistrarea nu a putut fi încărcată.",
    detailRulingDate: "Data hotărârii:",
    detailCourtAndRuling: "Instanța și hotărârea",
    detailSectionHeading: "Secția",
    detailSourceDoc: "Sursa documentului",
    detailHierarchy: "Ierarhia în culegere",
    detailProblemOfLaw: "Problema de drept analizată",
    detailRulingSummary: "Rezumatul soluției și argumentele",
    detailDoctrineNote: "Notă / Comentariu doctrinar",
    detailFullContent: "Conținut integral și motivare",
    detailExpand: "(extinde secțiunea)",
    detailNotSpecified: "Nu este precizat în culegere.",
  },
  en: {
    seoTitle: "Case Law Journal — legal analyses, cases, and judicial practice | Legea Aplicată",
    seoDesc: "Explore the Romanian Case Law Journal. Official digests of Courts of Appeal and tribunals, applied analyses, statutory bases, and best practices.",
    eyebrow: "Court digests and selections",
    title: "Case Law Journal",
    description: "Applied analyses, best practices, and legal issues extracted from the official case reporters of courts of appeal and tribunals.",
    totalRecords: "{count} judicial records",
    searchPlaceholder: "E.g.: statute of limitations, jurisdiction, unfair contract terms, termination...",
    searchButton: "Search",
    searchAriaLabel: "Search in Case Law Journal",
    exploreEyebrow: "Explore the collection",
    frequentMattersHeading: "Frequent legal domains",
    filtersToggle: "Filters",
    filtersHeading: "Legal filtering",
    closeFilters: "Close filters",
    activeFiltersLabel: "Active filters",
    resetFilters: "Reset filters",
    filterMatter: "Domain",
    allMatters: "All domains",
    filterCourt: "Court",
    allCourts: "All courts",
    filterSection: "Chamber",
    allSections: "All chambers",
    filterRulingType: "Ruling type",
    allRulingTypes: "All types",
    filterYear: "Year",
    allYears: "All years",
    filterSourceType: "Source document type",
    allSourceTypes: "All sources",
    filterIssuer: "Issuer",
    allIssuers: "All issuers",
    filterPath: "Path",
    allPaths: "All paths",
    filterSubpath: "Subpath",
    allSubpaths: "All subpaths",
    filterNote: "Note",
    allNotes: "All",
    withNote: "With note",
    withoutNote: "Without note",
    searching: "Searching…",
    resultsCount: "{count} results",
    resultsFor: "Results for “{query}”",
    defaultResultsTitle: "Court practice, structured and filterable",
    sortLabel: "Sort",
    sortRelevance: "Relevance",
    sortMostRecent: "Most recent",
    sortDateDesc: "Date descending",
    sortDateAsc: "Date ascending",
    sortCourtAsc: "Court A–Z",
    sortEditorial: "Source order",
    loadErrorTitle: "Could not load the journal.",
    loadingResults: "Loading results…",
    noResultsTitle: "No results found",
    noResultsDesc: "Try a shorter query or reset the filters.",
    paginationPrev: "Previous",
    paginationNext: "Next",
    paginationPage: "Page {page} of {total}",
    cardContainsNote: "Contains note",
    legalBasis: "Legal basis:",
    cardPage: "p. {start}",
    cardPageRange: "pp. {start}–{end}",
    cardReadAnalysis: "Read analysis",
    researchGuide: "Research guidelines",
    officialSourceLink: "Official court reporters — Portal of Courts of Justice",
    detailBreadcrumbHome: "Home",
    detailBreadcrumbJournal: "Case Law Journal",
    detailBack: "Back to Journal",
    detailLoadError: "The entry could not be loaded.",
    detailRulingDate: "Judgment date:",
    detailCourtAndRuling: "Court and ruling",
    detailSectionHeading: "Chamber",
    detailSourceDoc: "Source document",
    detailHierarchy: "Reporter hierarchy",
    detailProblemOfLaw: "Analyzed legal issue",
    detailRulingSummary: "Summary of ruling and reasoning",
    detailDoctrineNote: "Doctrinal note / commentary",
    detailFullContent: "Full text and judicial reasoning",
    detailExpand: "(expand section)",
    detailNotSpecified: "Not specified in the reporter.",
  },
  fr: {
    seoTitle: "Journal de pratique judiciaire — analyses, jurisprudence et doctrine | Legea Aplicată",
    seoDesc: "Explorez le Journal de pratique judiciaire en Roumanie. Recueils officiels des cours d'appel et tribunaux, analyses appliquées, fondements légaux et doctrine.",
    eyebrow: "Sélections et recueils des tribunaux",
    title: "Journal de pratique judiciaire",
    description: "Analyses appliquées, bonnes pratiques et questions de droit extraites des recueils officiels des cours d'appel et tribunaux.",
    totalRecords: "{count} décisions analysées",
    searchPlaceholder: "Ex. : prescription, compétence, clauses abusives, résiliation de contrat...",
    searchButton: "Rechercher",
    searchAriaLabel: "Rechercher dans le Journal de pratique judiciaire",
    exploreEyebrow: "Explorer la collection",
    frequentMattersHeading: "Matières fréquentes",
    filtersToggle: "Filtres",
    filtersHeading: "Filtrage juridique",
    closeFilters: "Fermer les filtres",
    activeFiltersLabel: "Filtres actifs",
    resetFilters: "Réinitialiser les filtres",
    filterMatter: "Matière",
    allMatters: "Toutes les matières",
    filterCourt: "Tribunal / Cour",
    allCourts: "Toutes les juridictions",
    filterSection: "Chambre",
    allSections: "Toutes les chambres",
    filterRulingType: "Type de décision",
    allRulingTypes: "Tous les types",
    filterYear: "Année",
    allYears: "Toutes les années",
    filterSourceType: "Type de document-source",
    allSourceTypes: "Toutes les sources",
    filterIssuer: "Émetteur",
    allIssuers: "Tous les émetteurs",
    filterPath: "Voie",
    allPaths: "Toutes les voies",
    filterSubpath: "Sous-voie",
    allSubpaths: "Toutes les sous-voies",
    filterNote: "Note",
    allNotes: "Toutes",
    withNote: "Avec note",
    withoutNote: "Sans note",
    searching: "Recherche en cours…",
    resultsCount: "{count} résultats",
    resultsFor: "Résultats pour « {query} »",
    defaultResultsTitle: "Jurisprudence organisée et filtrable",
    sortLabel: "Tri",
    sortRelevance: "Pertinence",
    sortMostRecent: "Plus récents",
    sortDateDesc: "Date décroissante",
    sortDateAsc: "Date croissante",
    sortCourtAsc: "Juridiction A–Z",
    sortEditorial: "Ordre dans le recueil",
    loadErrorTitle: "Impossible de charger le journal.",
    loadingResults: "Chargement des résultats…",
    noResultsTitle: "Aucun résultat trouvé",
    noResultsDesc: "Essayez une formulation plus concise ou réinitialisez les filtres.",
    paginationPrev: "Précédent",
    paginationNext: "Suivant",
    paginationPage: "Page {page} sur {total}",
    cardContainsNote: "Contient une note",
    legalBasis: "Fondement légal :",
    cardPage: "p. {start}",
    cardPageRange: "pp. {start}–{end}",
    cardReadAnalysis: "Lire l'analyse",
    researchGuide: "Repères de recherche",
    officialSourceLink: "Recueils officiels — Portail des juridictions de justice",
    detailBreadcrumbHome: "Accueil",
    detailBreadcrumbJournal: "Journal de pratique judiciaire",
    detailBack: "Retour au Journal",
    detailLoadError: "La décision n'a pas pu être chargée.",
    detailRulingDate: "Date du jugement :",
    detailCourtAndRuling: "Juridiction et décision",
    detailSectionHeading: "Chambre",
    detailSourceDoc: "Document source",
    detailHierarchy: "Hiérarchie du recueil",
    detailProblemOfLaw: "Question de droit analysée",
    detailRulingSummary: "Résumé de la décision et arguments",
    detailDoctrineNote: "Note doctrinale / commentaire",
    detailFullContent: "Contenu intégral et motivation",
    detailExpand: "(développer la section)",
    detailNotSpecified: "Non précisé dans le recueil.",
  },
};
